import { Component, OnInit } from "@angular/core";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";
import { Path } from "src/app/shared/model/enum";
import { TabsService } from "../../tabs/tabs.service";
import { Router } from "@angular/router";
import { Menu } from "src/app/shared/services/nav.service";
import {ListManagerService} from '../../../../components/list-manager/list-manager.service'
import { AgGridPaginationConfig, PaginationBaseModel, TablePaginationModel } from "../ag-grid.model";
import { AgGridService } from "../ag-grid.service";
@Component({
  selector: "app-text-renderer",
  templateUrl: "./text-renderer.component.html",
  styleUrls: ["./text-renderer.component.scss"],
})
export class TextRendererComponent implements OnInit, ICellRendererAngularComp
{
  dataToShow = "";
  params: any;
  enumPath = Path;
  paginationBaseModel = new PaginationBaseModel();
  tablePaginationModel = new TablePaginationModel();

  constructor(
    public listManagerService: ListManagerService,
    public agGridService: AgGridService,
  ) {}
  agInit(params: ICellRendererParams<any, any>): void {
    this.dataToShow = params.value;
    this.params = params;
  }
  refresh(params: ICellRendererParams<any, any>): boolean {
    return false;
  }

  ngOnInit(): void {}
  onTextClick(params) {
    params?.api?.deselectAll();
    const customEvent = new CustomEvent('textCellClick', {
      detail: { data: params },
    });
    document.dispatchEvent(customEvent); 
  
  }

}
